import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-home-tout',
  imports: [MatCardModule, MatIconModule, RouterLink, MatButtonModule, CommonModule],
  templateUrl: './home-tout.component.html',
  styleUrl: './home-tout.component.scss',
})
export class HomeToutComponent {
  @Input() public hero: string;
  @Input() public title: string;
  @Input() public titleIcon: string;
  @Input() public link: string;
  @Input() public linkText: string;
}
